/********************************************************************************
 * Copyright (c) 2023 Business Informatics Group (TU Wien) and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0 WITH Classpath-exception-2.0
 ********************************************************************************/
.toast {
    position: absolute;
    bottom: 48px; /* same as top of toolbar by default */
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 1rem;
    left: 40px; /* same as right of toolbar by default */
}

.toast-column-left {
    grid-column: 1 / span 1;
}

.toast-column-center {
    grid-column: 2 / span 1;
}

.toast-column-right {
    grid-column: 3 / span 1;
}

.toast-container {
    display: inline-block;
    min-width: 256px;
    max-width: 516px;
    background-color: #ccc;
    color: #000;
    padding: 0.5rem;
}
